export default {
  default: () => import("/usr/src/nuxt-app/layouts/default.vue").then(m => m.default || m),
  instacash: () => import("/usr/src/nuxt-app/layouts/instacash.vue").then(m => m.default || m),
  login: () => import("/usr/src/nuxt-app/layouts/login.vue").then(m => m.default || m),
  payment: () => import("/usr/src/nuxt-app/layouts/payment.vue").then(m => m.default || m),
  prescore: () => import("/usr/src/nuxt-app/layouts/prescore.vue").then(m => m.default || m),
  review: () => import("/usr/src/nuxt-app/layouts/review.vue").then(m => m.default || m),
  selfcare: () => import("/usr/src/nuxt-app/layouts/selfcare.vue").then(m => m.default || m)
}